import { useDispatch } from "react-redux";
import { convertTimestampToDaysAgo } from "../helpers/util";
import { baseQueryAPI } from "../services/baseQuery";
import { Spinner } from "./ui/Spinner";
import ListingLeadNotes from "./listing_details/ListingLeadNotes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { UpdateLeadStatus } from "./listing_details/UpdateLeadStatus";
import { setRefetch } from "../store/reducers/listingReducer";

export const RouteProperties = ({ public_id }: { public_id: string }) => {
  const {
    data: listing,
    error,
    isLoading,
    isFetching,
    isSuccess,
  } = baseQueryAPI.useRoutePropertiesQuery(public_id, {
    skip: !public_id,
  });

  console.log("listing", listing);

  if (isLoading || isFetching) {
    return (
      <td colSpan={6} align="center" className="p-4">
        <Spinner size={10} />
      </td>
    );
  }

  return (
    <td colSpan={6} className="w-full bg-slate-100 p-4">
      <div className="grid grid-cols-2 gap-2 w-full">
        {listing?.data?.map((item: any) => {
          return <RouteProperty key={item.public_id} listing={item} />;
        })}
      </div>
    </td>
  );
};

const RouteProperty = ({ listing }: { listing: any }) => {
  const [showEditLeadStatus, setShowEditLeadStatus] = useState(false);
  const dispatch = useDispatch();
  return (
    <div className="border border-gray-200 bg-white shadow-lg">
      <div className="p-4">
        <div>
          <div className="relative">
            <img
              src={
                "https://maps.googleapis.com/maps/api/streetview?size=356x200&location=" +
                listing.latitude +
                "," +
                listing.longitude +
                "&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4&source=outdoor"
              }
              alt="listing"
              className="w-full"
            />
            <div className="absolute flex justify-between w-full p-2 top-0">
              <span
                style={{ paddingTop: "2px", paddingBottom: "2px" }}
                className="px-2 border border-blue-200 bg-blue-50 text-blue-700 h-fit"
              >
                {convertTimestampToDaysAgo(listing.time_listed)}
              </span>
            </div>
          </div>

          <div className={`px-4 pb-4 pt-5`}>
            <div className="flex justify-between">
              {/* <span className="text-xl font-bold text-gray-900"></span> */}
              <div
                onClick={() => setShowEditLeadStatus(true)}
                className={"cursor-pointer flex items-center gap-x-1"}
              >
                <button>
                  <FontAwesomeIcon icon={faPenToSquare} />
                </button>
                <span className="px-2 py-1 text-gray-700 text-sm font-medium border border-gray-200 bg-gray-50">
                  {listing?.lead_status}
                </span>
              </div>
            </div>

            <div className="text-sm font-semibold text-primary mt-3 line-clamp-1 min-h-5">
              {listing.address}
            </div>

            <div className="mt-3 text-gray-900 text-lg font-medium line-clamp-1 min-h-6">
              {listing.name}
            </div>
          </div>
        </div>

        <div className="mt-4">
          <ListingLeadNotes currentListing={listing} />
        </div>
        {showEditLeadStatus && (
          <UpdateLeadStatus
            isOpen={showEditLeadStatus}
            close={() => {
              setShowEditLeadStatus(false);
              dispatch(setRefetch(true));
            }}
            currentListing={listing}
          />
        )}
      </div>
    </div>
  );
};
